<template>
  <v-autocomplete
      :search-input.sync="search"
      :error-messages="displayedErrors"
      :disabled="disabled"
      :hint="hintText"
      :label="labelText"
      :item-text="textField"
      :items="items"
      :item-value="valueField"
      :clearable="clearable"
      :append-icon="appendedIcon"
      :value="selectedItem"
      :hide-no-data="!noCompaniesFound"
      return-object
      hide-selected
      no-filter
      @click:append="appendedIconClicked"
      @click:clear="selectedItem = {}"
      @focus="noCompaniesFound = false"
      @input="emitData"
      @keyup.enter="searchItems(search)"
  >
    <template
        slot="selection"
        slot-scope="data"
    >
      <span>{{ data.item.name }} ({{ data.item.code }})</span>
    </template>
    <template
        slot="item"
        slot-scope="data"
    >
      <v-list-tile-content>
        <v-list-tile-title>
          <span>{{ data.item.name }}</span>
        </v-list-tile-title>
        <v-list-tile-sub-title class="body-2" style="font-size: 12px !important;">
          {{ data.item.code }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
    <template slot="append-outer">
      <v-tooltip
        :disabled="!!((search && search.length > 2) || selectedItem.code)"
        bottom
      >
        <v-btn
          :disabled="!search || search.length < 3 || loading"
          :loading="loading"
          slot="activator"
          color="primary"
          small
          @click="searchItems(search)"
        >
          {{ $t('search') }}
        </v-btn>
        <span>
          {{ $t('enter_three_or_more_symbols') }}
        </span>
      </v-tooltip>
    </template>
  </v-autocomplete>
</template>

<script>
/* eslint-disable no-unused-expressions */
export default {
  name: 'CompanyAutocomplete',

  props: {
    labelText: String,
    textField: String,
    valueField: {
      type: String,
      default: 'id',
    },
    hintText: {
      type: String,
      default: '',
    },
    searchRoute: String,
    errorMessages: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    appendedIcon: {
      type: String,
      default: 'arrow_drop_down',
    },
  },

  data() {
    return {
      displayedErrors: [],
      items: [],
      loading: false,
      search: null,
      selectedItem: {},
      noCompaniesFound: false,
    };
  },

  watch: {
    errorMessages(val) {
      this.displayedErrors = val;
    },
  },

  methods: {
    emitData(value) {
      this.selectedItem = value || {};
      this.displayedErrors = [];
      this.$emit('itemSelected', this.selectedItem);
      if (!value) {
        this.items = [];
      }
    },

    searchItems(v) {
      if (!v || v.length < 3) {
        return;
      }
      this.loading = true;
      this.$http.get(`${this.searchRoute}${v}`).then((resp) => {
        this.items = resp.data;
        this.noCompaniesFound = !this.items.length;
        this.loading = false;
      });
    },

    appendedIconClicked() {
      this.$emit('appendedIconClicked');
    },
  },
};
</script>
